import { render, staticRenderFns } from "./BaseTableHead.vue?vue&type=template&id=268a2e1c&functional=true&"
import script from "./BaseTableHead.vue?vue&type=script&lang=js&"
export * from "./BaseTableHead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports